import { render, staticRenderFns } from "./scoredata.vue?vue&type=template&id=7d5b8821&scoped=true"
import script from "./scoredata.vue?vue&type=script&lang=js"
export * from "./scoredata.vue?vue&type=script&lang=js"
import style0 from "./scoredata.vue?vue&type=style&index=0&id=7d5b8821&prod&lang=less"
import style1 from "./scoredata.vue?vue&type=style&index=1&id=7d5b8821&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5b8821",
  null
  
)

export default component.exports